import React from 'react';
import { CompositeDecorator, ContentState, convertFromRaw, Editor, EditorState } from 'draft-js';

import { isUniGroup } from './Helpers';
import store from '../redux/store';

import 'draft-js/dist/Draft.css';

const checkTypeObject = (str) => {
    try {
        if (!isNaN(str)) return false;
        JSON.parse(str);
        return true;
    } catch (err) {
        return false;
    }
};
function findLinkEntities(contentBlock, callback, contentState) {
    contentBlock.findEntityRanges((character) => {
        const entityKey = character.getEntity();
        return entityKey !== null && contentState.getEntity(entityKey).getType() === 'LINK';
    }, callback);
}

const Link = (props) => {
    const { url } = props.contentState.getEntity(props.entityKey).getData();
    return (
        <a href={url} target="_blank" rel="noreferrer">
            {props.children}
        </a>
    );
};

const decorator = new CompositeDecorator([
    {
        strategy: findLinkEntities,
        component: Link,
    },
]);

export const prepareMarketingConsent = (universityName) => {
    const { institution } = store.getState().widget;
    const uniGroup = isUniGroup();

    if (uniGroup || institution?.isMarketingConsentDefault) {
        return 'I agree to receive email marketing communications from ' + universityName;
    } else if (!institution.isMarketingConsentShown) {
        return null;
    } else if (
        institution.isMarketingConsentShown &&
        !institution.isMarketingConsentDefault &&
        institution.marketingConsentText
    ) {
        return getMarketingConsent(institution.marketingConsentText);
    }
};

export const getMarketingConsent = (text) => {
    const stringType = checkTypeObject(text);
    let answer_text = '';
    const answer_text_temp = stringType ? JSON.parse(text) : text;
    let showTextLink = false;
    let totalNumber = 0;

    if (stringType) {
        answer_text = { ...answer_text_temp };
        const blocks = [];
        for (const block of answer_text.blocks) {
            let blockText = '';
            if (block.text) {
                for (let i = 0; i < block.text.length; i++, totalNumber++) {
                    blockText += block.text[i];

                    if (block.text[i] === '\n') {
                        totalNumber += 25;
                    } else if (block.text[i] === 's') {
                        totalNumber -= 1;
                    }
                }
                block.text = blockText;
                blocks.push(block);
                totalNumber += 25;
            }
            if (showTextLink) break;
        }

        if (blocks.length > 0) {
            answer_text.blocks = blocks;
        }
    } else {
        if (answer_text_temp) {
            for (let i = 0; i < answer_text_temp.length; i++, totalNumber++) {
                answer_text += answer_text_temp[i];

                if (answer_text_temp[i] === '\n') {
                    totalNumber += 25;
                } else if (answer_text_temp[i] === 's') {
                    totalNumber -= 1;
                }
            }
        }
    }

    const content = stringType
        ? EditorState.createWithContent(convertFromRaw(answer_text), decorator)
        : EditorState.createWithContent(ContentState.createFromText(answer_text), decorator);

    return <Editor readOnly={true} editorState={content} onChange={() => {}} />;
};
